import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathLessThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"math-less-than, <"} maskId="square-filled-radius-0-stroke-1-IconMathLessThan"><path fillRule="evenodd" clipRule="evenodd" d="M19.3936 5.34473L4.84473 11.5L19.3936 17.6553L19.7833 16.7344L7.4112 11.5L19.7833 6.26569L19.3936 5.34473Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMathLessThan;
